app.controller("SeasonController", ["$scope", "Season", "$uibModal", "ConfirmModal", "$state", function ($scope, Season, $uibModal, ConfirmModal, $state) {
    function fetchSeasons() {
        Season.list()
            .then(function (result) {
                $scope.seasons = result;
            });
    }

    fetchSeasons();

    $scope.add = function () {
        $uibModal.open({
            controller: "AddSeasonController",
            templateUrl: _pb + 'sudo/seasons/add-season.html',
            size: "md"
        }).result.then(function (result) {
            fetchSeasons();
        }, function () {
        });
    };

    $scope.removeSeason = function (season, event) {
        event.stopPropagation();

        ConfirmModal.show({
            title: "სეზონის წაშლა",
            message: 'გსურთ "' + season.year + " " + season.season + '" სეზონის წაშლა ?'
        }).result.then(function () {
            Season.delete(season._id)
                .then(function () {
                    fetchSeasons();
                });
        });
    };

    $scope.toSeasonWeeks = function (season) {
        $state.go("^.season-weeks", {seasonId: season._id});
    };
}]);
